import { initializeApp } from "firebase/app";
// Import initializeFirestore instead of getFirestore
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; 

const firebaseConfig = {
  apiKey: "AIzaSyDIOMSP8VTih0vCj_eLpsNNYETUZkisTJQ",
  authDomain: "wedding-platform-c3af3.firebaseapp.com",
  projectId: "wedding-platform-c3af3",
  storageBucket: "wedding-platform-c3af3.firebasestorage.app",
  messagingSenderId: "484166826958",
  appId: "1:484166826958:web:9a1e725537737f43e8c99f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// --- MODIFIED LINE BELOW ---
// We use initializeFirestore with experimentalForceLongPolling
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();